<ngx-loading-bar></ngx-loading-bar>
<div class="container text-center">
  <alert></alert>
</div>

<router-outlet></router-outlet>

<!-- <app-tap-to-top></app-tap-to-top> -->
<!-- <button *ngIf="Pwa.promptEvent" (click)="installPwa()">
    Install
  </button> -->
<!-- <app-layout-box></app-layout-box> -->
<!-- <div class="main-action-sheet " >
  <div class="action-sheet d-flex flex-column" style="gap: 0.75rem;">
    <img src="../assets/icons/icon-background.png" alt="">
    <p class="pl-2">Do you want to download the app </p>
<div class="d-flex justify-content-between">
  <button class="btn btn-danger" (click)="resolveInstallPromise(false)">Cancel</button>
  <button class="btn btn-primary" (click)="resolveInstallPromise(true)">Install</button>
</div>
  </div>
</div> -->